import React from "react";
import GitHubCalendar from "react-github-calendar";
import "./css/Github.css";

export const GitHub = () => {
  return (
    <div className="github">
      <h1 className="githubTitle">GitHub Stats</h1>

      <div className="github_Calender">
        <GitHubCalendar
        style={{margin:"auto"}}
          username="rozodkarbharat"
          year={new Date().getFullYear()}
        />
      </div>
    </div>
  );
};
